import { croreLabel } from "@/lib/currency";

export const firmStats = [
  { value: croreLabel(500, true), label: "Capital deployed" },
  { value: "50+", label: "Mandates executed" },
  { value: "12+", label: "Years in credit" },
  { value: "India", label: "Primary market" },
] as const;

export const pillars = [
  {
    title: "Flexible platform",
    description:
      "We invest through cycles with structures suited to each borrower — from senior secured debt to hybrid capital — scaling execution with institutional discipline.",
  },
  {
    title: "Differentiated access",
    description:
      "Deep relationships across lenders, sponsors, and operating partners give us sourcing and structuring advantages in mid-market private credit.",
  },
  {
    title: "Partnership approach",
    description:
      "Bespoke solutions, transparent reporting, and long-term alignment with founders, CFOs, and allocators who require certainty—not noise.",
  },
] as const;

export const services = [
  {
    title: "Private Credit",
    description:
      "Asset-backed and cash-flow lending for growth-stage borrowers and special situations.",
  },
  {
    title: "Debt Advisory",
    description:
      "Capital raising strategy, lender syndication, and end-to-end transaction execution.",
  },
  {
    title: "Structured Finance",
    description:
      "Bespoke structures across senior debt, mezzanine, and hybrid capital solutions.",
  },
  {
    title: "Special Situations",
    description:
      "Capital for turnaround, stressed credits, and complex corporate requirements.",
  },
  {
    title: "Growth Capital",
    description:
      "Flexible financing for expansion, capex, and strategic initiatives.",
  },
  {
    title: "Wealth Advisory",
    description:
      "Portfolio design and alternative access for HNIs and family offices.",
  },
] as const;

export const transactions = [
  { amount: croreLabel(200), label: "Renewable Energy Debt Raise" },
  { amount: croreLabel(90), label: "Education Financing" },
  { amount: croreLabel(50), label: "Hospitality Expansion Funding" },
  { amount: croreLabel(200), label: "Logistics Debt Raise" },
] as const;

export const insights = [
  {
    title: "Private Credit in India: Q1 2026 Outlook",
    category: "Market Insights",
    date: "March 2026",
  },
  {
    title: "Debt Market Report — Mid-Market Borrowers",
    category: "Debt Market Reports",
    date: "February 2026",
  },
  {
    title: "Founder's Guide to Structured Finance",
    category: "Financing Guides",
    date: "January 2026",
  },
] as const;
